import Hexagon from '../../../../assets/hexagon_empty.svg?react';
import './hex-container.less';

interface HexContainerProps {
  icon?: React.ReactNode;
  className?: string;
}

export const HexContainer = ({ icon, className }: HexContainerProps) => {
  return (
    <div className={className}>
      <span>{icon}</span>
      <Hexagon />
    </div>
  );
};
